module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABfSURBVHgB7dO7CcAwDITh06bZxBklm14SMCQIvyQZV/5BjYqvO2C3JJLHe5jRAyV+JURSWAxV2JnPh2rs97ejNcyF9jATOooNoVasiXqxKhrBSqgwT0pELgTirGnucAP1ShwY2MT9MQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio/btn_player_arrowup.png
// module id = Ey2b
// module chunks = 1